module.exports = __webpack_public_path__ + "static/media/table_add.3eba910a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/table_add.svg
// module id = 1714
// module chunks = 0